export default "__VITE_ASSET__CMgHNJla__"